<script>
import Multiselect from 'vue-multiselect'
import { permsMethods, usersMethods} from '@state/helpers'


import _ from 'lodash'

export default {
    name: 'GroupsUpdateForm',
    components: { Multiselect },
    props: {
        onformsubmit: {
            type: Function,
            required: true
            },
        validator: {
            type: Object,
            required: true
            },
        form: {
            type: Object,
            required: true
            }
    },
    data() {
        return {
            permsOptions: [],
            usersOptions: [],
            permsOptionsCache: [],
            usersOptionsCache: [],
            loadingPermsOptions: false,
            loadingUsersOptions: false,
            permsOptionsMounted: false,
            usersOptionsMounted: false
        }
    },
    mounted(){
        this.populateAppPermsOptions()
        this.populateUsersOptions()
    },
    methods: {
        ...permsMethods,
        ...usersMethods,
        populateAppPermsOptions(searchQuery){
            // Filters only AppPerms type=2,
            // Section perms corresponds to sections
            let context = this
            context.loadingPermsOptions = true
            let reqParams = context.$select_params(searchQuery)
            reqParams = `${reqParams}${!reqParams ? '?' : '&'}permission_type=2`
            const promise = context.fetchPerms(reqParams)
            return promise.then(data => {
                let listOptions = []
                data.results.forEach(opt => {
                    listOptions.push({
                        'url': opt.permission.url,
                        'name': opt.permission.name
                    })
                });
                context.permsOptions = listOptions
                context.loadingPermsOptions = false
                context.permsOptionsMounted = true
            }).catch(error => {
                context.$axios_error_noty(error, context)
                context.loadingPermsOptions = false
                context.permsOptionsMounted = true
            })
        },
        populateUsersOptions(searchQuery){
            let context = this
            context.loadingUsersOptions = true
            let reqParams = context.$select_params(searchQuery)
            const promise = context.fetchUsersForOptions(reqParams)
            return promise.then(data => {
                let listOptions = []
                data.results.forEach(opt => {
                    listOptions.push({
                        'url': opt.url,
                        'name': opt.first_name ? `${opt.first_name} ${opt.last_name } (${opt.username})` : opt.username
                    })
                });
                context.usersOptions = listOptions
                context.loadingUsersOptions = false
                context.usersOptionsMounted = true
            }).catch(error => {
                context.$axios_error_noty(error, context)
                context.loadingUsersOptions = false
                context.usersOptionsMounted = true
            })
        },
        labelOfAppPerms(opt){
            let permsOptionsFounded = this.permsOptions.find(x => x.url === opt)
            if (!permsOptionsFounded){
                let cacheFounded = this.permsOptionsCache.find(x => x.url === opt)
                return  cacheFounded ? cacheFounded.name : this.permsOptionsMounted ? `Not found in options: ${opt}`: ''
            }else{
                if (this.form.permissions.find(x => x === opt)){
                    if (!this.permsOptionsCache.find(x => x.url === opt)){
                        this.permsOptionsCache.push(permsOptionsFounded)
                    }
                }
                return permsOptionsFounded.name
            }
        },
        labelOfUsersOptions(opt){
            let usersOptionsFounded = this.usersOptions.find(x => x.url === opt)
            if (!usersOptionsFounded){
                let cacheFounded = this.usersOptionsCache.find(x => x.url === opt)
                return  cacheFounded ? cacheFounded.name : this.usersOptionsMounted ? `Not found in options: ${opt}`: ''
            }else{
                if (this.form.user_set.find(x => x === opt)){
                    if (!this.usersOptionsCache.find(x => x.url === opt)){
                        this.usersOptionsCache.push(usersOptionsFounded)
                    }
                }
                return usersOptionsFounded.name
            }
        },
        asyncFindPerms: _.debounce(function (searchQuery) {
            this.populateAppPermsOptions(searchQuery)
        }, 600),
        asyncFindUsers: _.debounce(function (searchQuery) {
            this.populateUsersOptions(searchQuery)
        }, 600)
    }
}
</script>
<template>
    <b-form  id="form" @submit="onformsubmit" >
        <form-wrapper :validator="validator ">
        <div>
            <form-summary/>
        </div>
        <form-group name="name" label="Name">
            <b-form-input
                v-model="form.name"
                slot-scope="{ attrs, listeners }"
                v-bind="attrs"
                v-on="listeners"
            />
        </form-group>
        <form-group name="description" label="Description">
            <div>
                <b-form-textarea
                    id="textarea"
                    v-model="form.description"
                    placeholder="Description"
                ></b-form-textarea>
            </div>
        </form-group>
        <form-group name="perms-select" label="Permissions">
            <Multiselect
                id="perms-select"
                v-model="form.permissions"
                :multiple="true"
                :options="permsOptions.map(x => x.url)"
                :custom-label="opt => labelOfAppPerms(opt)"
                :loading="loadingPermsOptions"
                :internal-search="false"
                @search-change="asyncFindPerms">
            </Multiselect>
        </form-group>
        <form-group name="members-of-select" label="Members of">
            <Multiselect
                id="members-of-select"
                v-model="form.user_set"
                :multiple="true"
                :options="usersOptions.map(x => x.url)"
                :custom-label="opt => labelOfUsersOptions(opt)"
                :loading="loadingUsersOptions"
                :internal-search="false"
                @search-change="asyncFindUsers">
            </Multiselect>
        </form-group>
        </form-wrapper>
    </b-form>
</template>